import { render, staticRenderFns } from "./DuplaChecagem.vue?vue&type=template&id=258f3ffc&scoped=true&"
import script from "./DuplaChecagem.vue?vue&type=script&lang=js&"
export * from "./DuplaChecagem.vue?vue&type=script&lang=js&"
import style0 from "./DuplaChecagem.vue?vue&type=style&index=0&id=258f3ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258f3ffc",
  null
  
)

export default component.exports